import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { BaseComponent, ConfigurationService, LoggerService, SecurityService, BlobService } from 'saker-core';

import { saveFile } from 'saker-core';
import { NoteDTO } from 'src/app/Protocol/note.dto';


@Component({
  selector: 'app-location-file',
  templateUrl: './location-file.component.html',
  styleUrls: ['./location-file.component.css']
})
export class LocationFileComponent extends BaseComponent implements OnInit {

  // -----------------------------------
  // Model
  // -----------------------------------

  @Input() owner: NoteDTO | null = null;
  @Input() modify: boolean = false;
  @Input() dirty: boolean = false;

  @Output() filesChanged = new EventEmitter();

  base = this.configuration.CONFIG.BLOB_URL;

  file: File | null = null;

  loadDisabled: boolean = true;
  progressMessage: string = "";

  isCollapsed: boolean = false;

  // -----------------------------------
  // Behaviour
  // -----------------------------------

  removeAttachment(reference: string) {

    
    if (this.owner) {
      let found = this.owner.attachments.findIndex(function (element: any) {
        
        return element.reference == reference
      });
      
      if (found != -1) {
        console.info('deleting:' + found);
        this.owner.attachments.splice(found, 1);
        this.dirty = true;
        this.filesChanged.emit()
      }
    }

  }

  updateFile(event: any) {
      this.file = event.target.files[0];
  }


  download(guid: string, fileName: string) {

    this.blobService.getBlob(guid)
      .subscribe((data) => {
        saveFile(data, fileName);
      });

  }

  nameOnly(item: string) {
    return item.replace(/^.*[\\\/]/, '')
  }


  upload(item: NoteDTO) {

    if (this.file) {
    
      return this.blobService.saveBlob("undefined", "undefined", this.file, this.progress)
        .subscribe((data: any) => {

          let applicationFile:any = {
            name: data.name,
            reference: data.guid,
            fileName: data.fileName,
            fileSize: data.size,
            fileType: data.type,
            dateAdded: data.creation,
            historical: data.dummy,
            attachmentId:data.dummy,
            encodedRowVersion:data.dummy,
            scenarioId:data.dummy
          };

          item.attachments.push(applicationFile);

          this.file = null;

          this.dirty = true;

          this.logger.success('Document Uploaded');

          this.filesChanged.emit()

        });
    } else {
      return;
    }

  }

  // -----------------------------------
  // Private
  // -----------------------------------

  private progress(value: number) {
    if (value == 100) {
      this.loadDisabled = false;
      this.progressMessage = "";
    }
    else {
      this.loadDisabled = true;
      this.progressMessage = "Loading... " + value + "%";
    }
  }

  //-------------------------------
  // Form
  //-------------------------------

  //-------------------------------
  // System
  //-------------------------------
  
  constructor(
    security: SecurityService,
    configuration: ConfigurationService,
    logger: LoggerService,
    router: Router,
    modal: NgbModal,
    changeDetectorRef: ChangeDetectorRef,
    private blobService: BlobService,
  ) {
    super(security, configuration, logger, router, modal, changeDetectorRef);
  }

  ngOnInit(): void {
    
  }

}
